module.exports = __webpack_public_path__ + "img/dni.3f16c866.svg";